module.exports = __webpack_public_path__ + "static/media/omega-banner.16b70fb4.png";